import React from 'react';

import { NavigationListItem } from '../NavigationListItem';

import { SearchBarModal } from '@/components/SearchBar/SearchBarModal';
import { useIsGuestLikesEnabled } from '@/modules/guestLikes/hooks/useIsGuestLikesEnabled';

export function NavigationMobileSearchBarButton() {
  const isGuestLikesVariant = useIsGuestLikesEnabled();

  return (
    <NavigationListItem displayBreakpoint="lgDown">
      <SearchBarModal isCompact={isGuestLikesVariant} />
    </NavigationListItem>
  );
}
